var _ = require('underscore');

const alphabeticalSort = (a,b) => {
  var nameA =(a?.name || '').toString().toUpperCase(); // ignore upper and lowercase
  var nameB = (b?.name || '').toString().toUpperCase(); // ignore upper and lowercase
  return nameA.localeCompare(nameB);
}

const coderSort = (a,b) => {
  // selected codes go first
  if ( !!a.selected !== !!b.selected ) return a.selected ? -1 : 1;

  const timeA = a && a.time ? a.time : '';
  const timeB = b && b.time ? b.time : '';
  return timeB.localeCompare(timeA);
};


function getCodes(excerpts, selectedExcerptId, isSelectInsideParagraph) {
  const selectedExcerpt = isSelectInsideParagraph && !!selectedExcerptId ? excerpts.find((e)=>e.id.toString() === selectedExcerptId.toString()) : null;
  // Get selected code_ids from the selected excerpt's codings
  const selectedCodeIds = selectedExcerpt ? (selectedExcerpt?.codings || []).map((coding)=>coding.code_id) : [];

  var codes = _.chain(excerpts ||  []).map((excerpt)=>{
      const isSelectedExcerpt = !!selectedExcerpt && excerpt.id.toString() === selectedExcerptId.toString();
      
      // Group codings by code_id to form code objects with coders
      return _.chain(excerpt?.codings || [])
        .groupBy((coding) => coding.code_id)
        .map((codings, code_id) => {
          // Use the first coding to get common code properties
          const codeBase = codings[0]?.code || {};
          
          return {
            ...codeBase,
            id: code_id,
            selected: selectedCodeIds.includes(parseInt(code_id) || code_id),
            coders: codings.map((coding) => {
              return {
                id: coding.user_id,
                time: coding.created_at || coding.updated_at,
                user_id: coding.user_id,
                selected: isSelectedExcerpt
              }
            })
          };
        })
        .filter((code) => !!code)
        .value();
    }
  ).flatten().value();

  const flattened = _.chain(codes)
  .groupBy((c)=>c.id)
  .mapObject((codes, id)=>{
    return codes.reduce((acc, code)=>{
      const coders = _.chain([
        ...(acc.coders || []),
        ...(code.coders || [])
      ]).groupBy((c)=>c.id).mapObject((userCodings, userId)=>{
        // return the userCoding with the most recent userCodings
        const selectedCodings = userCodings.filter((c)=>c.selected);
        const possilbeCodings = selectedCodings.length > 0 ? selectedCodings : userCodings;
        return _.max(possilbeCodings, (c)=>Date.parse(c.time || 0));
      }).values().value();

      return {
        ...acc,
        ...code,
        coders: coders.sort(coderSort)
      }
    }, {});
  }).values().value().sort(alphabeticalSort)
  
  return flattened;
}


export default getCodes;
